import React, { useCallback, useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import Flex from '../../Tool-kit/Flex'
import logo from '../../assests/images/Logo.png'
import Text from '../../Tool-kit/Typography'
import Button from '../../Tool-kit/Button'
import ThemeToggle from '../ThemeToggle'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import { MenuItem } from '@mui/material'
import { Select } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useMediaQuery } from '@mui/material'
import { useQuery, useMutation } from 'react-apollo'
import { SET_ERROR } from 'graphql/mutations'
import GlobalState from '../../globalState'
import { connect, disconnect } from '../../api/web3modal'
import useNetworkInfo from '../../components/NetworkInformation/useNetworkInfo'
import { useLocale } from 'hooks/useLocale'
import { useTranslation } from 'react-i18next'
import { KeyboardArrowDownOutlined } from '@mui/icons-material'
import useThemeContext from 'hooks/useThemeContext'

const HeaderWrapper = styled.header`
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);

  background: ${({ theme }) => theme.colors.background2};
`

const Wrapper = styled(Flex)`
  padding: 2.3rem 10rem;
  .logo {
    max-width: 14rem;
    height: auto;
  }
  @media only screen and (max-width: 1310px) {
    padding: 2.3rem 5rem;
  }
  @media ${devices.tabland} {
    padding: 2.3rem 4rem;
  }
  @media ${devices.tabport} {
    padding: 2.3rem 2rem;
  }
  @media ${devices.phone} {
    padding: 2.3rem 2rem;
    .logo {
      height: auto;
      max-width: 100%;
    }
  }

  .nav {
    @media ${devices.tabport} {
      display: none;
    }
    cursor: pointer;
  }

  svg {
    max-width: 100%;
    height: auto;
  }

  @media screen and (min-width: 1440px) {
    width: 1440px;
    margin: auto;
  }
`

const ToggleIcon = styled.div`
  position: relative;
  opacity: 1;
  margin-right: 2rem;
  &,
  &::before,
  &::after {
    width: 3rem;
    height: 2px;
    z-index: 1200;
    display: none;
    @media ${devices.tabport} {
      display: inline-block;
      background-color: ${({ theme }) => theme.colors.textPrimary};
    }
  }
  & {
    background-color: ${({ isMobileNav, theme }) =>
      isMobileNav ? 'transparent' : theme.colors.textPrimary};
  }
  &::before,
  &::after {
    content: '';
    position: absolute;
    transition: all 0.2s;
    top: 0px;
  }
  &::before {
    top: ${({ isMobileNav }) => (isMobileNav ? '0' : '-.8rem')};
    transform: ${({ isMobileNav }) => (isMobileNav ? 'rotate(135deg)' : '')};
  }
  &::after {
    top: ${({ isMobileNav }) => (isMobileNav ? '0' : '.8rem')};
    transform: ${({ isMobileNav }) => (isMobileNav ? 'rotate(-135deg)' : '')};
  }
`

const MobileNav = styled.div`
  left: 0px;
  position: absolute;
  top: 6.5rem;
  z-index: 5;
  width: 100%;
  background: #0f0e1e;
  padding: 4rem;
  gap: 2rem;
  flex-direction: column;
  transition: all 1s;
  transform: translateX(-100rem);
  visibility: hidden;
  display: flex;
  margin-top: 2rem;
  background: black;
  padding-bottom: 10rem;

  .mobile-links {
    border-bottom: 1px solid #181818;
    padding: 2rem 0rem;
    cursor: pointer;
  }

  @media ${devices.tabport} {
    transform: ${({ isMobileNav }) => (isMobileNav ? 'translateX(0rem)' : '')};
    visibility: ${({ isMobileNav }) => (isMobileNav ? 'visible' : 'hidden')};
  }
`

const Header = ({ isMobileNav, setIsMobileNav }) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { switchNetwork, currentNetwork } = useContext(GlobalState)
  const { accounts, network, loading, refetch, isReadOnly } = useNetworkInfo()
  const isMobile = useMediaQuery(devices.phone)
  const isTabland = useMediaQuery(devices.tabland)
  const [setError] = useMutation(SET_ERROR)
  const { locale, setLocale } = useLocale()
  const { isDark } = useThemeContext()
  const navLinks = [
    {
      label: t('c.domains'),
      path: '/'
    },
    {
      label: t('c.account'),
      path: '/account'
    },
    {
      label: t('c.learn'),
      path: '/learn'
    },
    {
      label: t('c.faq'),
      path: '/faq'
    },
    {
      label: t('c.affliate'),
      path: '/affliate'
    },
    {
      label: t('c.contact'),
      path: '/contact'
    }
  ]

  const handeLocaleChange = e => {
    setLocale(e.target.value)
  }

  const [selectedNav, setSelectedNav] = useState()

  const onToggleMobileNav = useCallback(() => {
    setIsMobileNav(!isMobileNav)
  }, [isMobileNav, setIsMobileNav])

  useEffect(() => {
    setSelectedNav(pathname)
  }, [pathname])

  const navigationPush = useCallback(
    path => {
      setSelectedNav(path)
      setIsMobileNav(false)
    },
    [setIsMobileNav]
  )

  const handleConnect = async () => {
    setIsMobileNav(false)
    let network
    try {
      network = await connect()
    } catch (e) {
      setError({ variables: { message: e && e.message } })
    }
    if (network) {
      switchNetwork(network.chainId)
    }
    location.reload()
  }

  const handleDisconnect = async () => {
    setIsMobileNav(false)
    await disconnect()
    switchNetwork(1)
    location.reload()
  }

  return (
    <>
      <HeaderWrapper>
        <Wrapper justifyContent="space-between">
          <Flex gap="2rem">
            <Flex justifyContent="left" gap={isTabland ? '2rem' : '3rem'}>
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              {navLinks.map(item => (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={() => navigationPush(item.path)}
                  className="nav"
                >
                  <Text
                    font="h6Bold"
                    fontWeight="500"
                    color={
                      selectedNav === item.path ? 'bnbYellow' : 'textPrimary'
                    }
                  >
                    {item.label}
                  </Text>
                </Link>
              ))}
            </Flex>
          </Flex>
          <Flex gap={isMobile ? '1.5rem' : '1.5rem'}>
            <div className="nav">
              <Button
                height="4.4rem"
                width="20rem"
                roundedCorners
                padding="2rem 1rem"
                onClick={isReadOnly ? handleConnect : handleDisconnect}
              >
                {isReadOnly ? t('c.connect') : t('c.disconnect')}
              </Button>
            </div>
            <Select
              value={locale}
              onChange={handeLocaleChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              className="nav"
              sx={{
                fontSize: '1.4rem',
                '& .MuiOutlinedInput-input': {
                  color: isDark ? '#FFFFFF' : '#000000'
                },
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none'
                },
                '.MuiSelect-icon': {
                  color: isDark ? '#FFFFFF' : '#000000'
                }
              }}
              IconComponent={KeyboardArrowDownOutlined}
            >
              <MenuItem value="en">{t('c.english')}</MenuItem>
              <MenuItem value="vi">{t('c.vietnamese')}</MenuItem>
            </Select>
            <ThemeToggle />
            {/* <Popup /> */}
            <ToggleIcon onClick={onToggleMobileNav} isMobileNav={isMobileNav} />
          </Flex>
        </Wrapper>
      </HeaderWrapper>
      <MobileNav isMobileNav={isMobileNav}>
        {navLinks.map(item => (
          <div className="mobile-links" key={item.label}>
            <Link
              key={item.label}
              to={item.path}
              onClick={() => navigationPush(item.path)}
            >
              <Text
                font="h5Bold"
                color={selectedNav === item.path ? 'bnbYellow' : 'white'}
              >
                {item.label}
              </Text>
            </Link>
          </div>
        ))}
        <Flex gap="2rem" mb="1rem">
          <Button
            height="4.4rem"
            onClick={isReadOnly ? handleConnect : handleDisconnect}
          >
            {isReadOnly ? t('c.connect') : t('c.disconnect')}
          </Button>
          <Select
            value={locale}
            onChange={handeLocaleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            sx={{
              fontSize: '1.2rem',
              '& .MuiOutlinedInput-input': {
                color: '#FFFFFF'
              },
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none'
              },
              '.MuiSelect-icon': {
                color: '#FFFFFF'
              }
            }}
            IconComponent={KeyboardArrowDownOutlined}
          >
            <MenuItem value="en">{t('c.english')}</MenuItem>
            <MenuItem value="vi">{t('c.vietnamese')}</MenuItem>
          </Select>
        </Flex>
      </MobileNav>
    </>
  )
}

export default Header
